import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { ColorNames } from '@/utils/constants';
import CardSkeleton from './Card/CardSkeleton';

const useSearchResultPlaceholderStyles = makeStyles({
  root: {
    width: '100%',
    gap: '30px',
    display: 'grid',
    gridTemplateColumns: '1fr',
  },
});

export const SearchResultPlaceholder = ({ theme, itemCount = 2 }: PropsWithTheme<any>) => {
  const classes = useSearchResultPlaceholderStyles();
  return (
    <div className={clsx(classes.root)}>
      {[...Array(itemCount)].map((_item, i) => (
        <CardSkeleton key={i} theme={theme} cardColor={ColorNames.white} animated={false} />
      ))}
    </div>
  );
};
